/**
 * Which of the four situations the live-stream button is in.
 *
 * Kept out of the component so the mapping can be read and tested on its own:
 * "idle" and "live" are settled and stay clickable, "connecting" and "stopping"
 * are transient and disable the button so a second press cannot land mid-flight.
 */
export function streamButtonState({ isStreaming, isStreamLoading, isStoppingStream }) {
  // The operator's most recent intent wins, even if a connect was still pending.
  if (isStoppingStream) return 'stopping';

  // Requested, but no frame has arrived yet - this is the wait that used to look
  // like nothing was happening.
  if (isStreaming && isStreamLoading) return 'connecting';

  if (isStreaming) return 'live';

  // A loading flag with no stream behind it means the start never landed.
  return 'idle';
}

export const BUSY_STATES = ['connecting', 'stopping'];

export function isStreamButtonBusy(state) {
  return BUSY_STATES.includes(state);
}
